import { render, staticRenderFns } from "./MwanPayment.vue?vue&type=template&id=1b954578&scoped=true"
import script from "./MwanPayment.vue?vue&type=script&lang=js"
export * from "./MwanPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b954578",
  null
  
)

export default component.exports